ActionList = require 'models/collections/action-list'
ActionListView = require 'views/action/action-list-view'
MemberView = require 'views/member/member-view'
OrganizationListView = require 'views/organization/organization-list-view'
Payloads = require 'network/payloads'
ViewWithActions = require 'views/internal/view-with-actions'
mixin = require 'lib/mixin'
templates = require 'views/internal/templates'
track = require 'debug/track'

module.exports = mixin ViewWithActions, class MemberProfileView extends MemberView

  events:
    'click .js-more-actions': 'loadMoreActionsAndRemoveDateLimit'

  initialize: ->
    super

    track('Member Profile Page', 'Open')

    @limit = 10
    @nextPage = 1 + Math.floor(@getActions().length / @limit)

    @daysBack = Payloads.memberProfile_daysBack
    @actionListView = @collectionSubview ActionListView, new ActionList(@getActions(), { @modelCache }),
      renderOpts:
        context: @model
        showBoard: true
        showOrganization: true
        readOnly: true

    @listenTo @model.organizationList, 'add remove reset',
      @frameDebounce @renderMainContent

    @listenTo @modelCache, "add:Action:#{@model.id}", =>
      @actionListView.collection.reset(@getActions(), silent: true)
      @renderActions()

  renderMainContent: ->
    data = @model.toJSON()

    @setActiveView('.js-member-profile')

    @$('.js-content').html(
      templates.fill(
        'member_profile',
        data
      )
    )

    # make sure everything we can paint is painted first, ask questions later
    @defer =>
      if @model.organizationList.length > 0
        orgListView = @subview(OrganizationListView, @model)
        $listOrgs = @$('.js-list-orgs').empty()
        @appendSubview orgListView, $listOrgs
      else
        @$('.js-list-orgs').closest('.window-module').hide()

      @actionListView.setElement(@$('.list-actions')[0])
      @renderActions()

    @

  renderActions: ->
    if @actionListView.collection.length == 0
      @actionListView.$el.html templates.fill('actions_empty', { @daysBack })
    else
      @actionListView.render()
    @$('.js-more-actions').toggleClass('hide', !@hasMoreActionsOrDateLimited())
    @

  hasMoreActionsOrDateLimited: ->
    @daysBack? || @hasMoreActions()

  loadMoreActionsAndRemoveDateLimit: ->
    @daysBack = null
    @loadMoreActions()

  getActionsFilter: ->
    Payloads.memberActions



// WEBPACK FOOTER //
// ./app/scripts/views/member/member-profile-view.coffee